import { Link } from 'react-router'

// In an empty section someone only looks at (Just see, in What I use), in place of the button to add the first one.
export function JustSeeing() {
  return (
    <p className="text-table-muted">
      When someone shares one, it shows here. You’ve set this to Just see on{' '}
      <Link to="/me" className="text-brand underline underline-offset-4">
        My profile
      </Link>
      .
    </p>
  )
}
